console.log('js/gototop_btn.js -> v0.1.0');

$(function() {
	// Click event to scroll to top
	$clickables = $(".gototop");
	if ($clickables.length > 0) {
		$clickables.on("click", function(e) {
			$('html, body').animate({scrollTop : 0},400);
			e.preventDefault();
		});

		$(document).scroll(function(){
			var currentPos = $(this).scrollTop();
			if (currentPos > 584) {
				$('.gototop-btn').fadeIn();
			} else {
				$('.gototop-btn').fadeOut();
			}
		});
	}
});
